import React from 'react';

const BidStatusBadge = ({ status }) => {
  const statusConfig = {
    Draft: {
      bg: 'bg-muted',
      text: 'text-muted-foreground',
      label: 'Draft'
    },
    Submitted: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      text: 'text-blue-700 dark:text-blue-300',
      label: 'Submitted'
    },
    Accepted: {
      bg: 'bg-green-100 dark:bg-green-900/30',
      text: 'text-green-700 dark:text-green-300',
      label: 'Accepted'
    },
    Rejected: {
      bg: 'bg-red-100 dark:bg-red-900/30',
      text: 'text-red-700 dark:text-red-300',
      label: 'Rejected'
    },
    'Converted to Project': {
      bg: 'bg-purple-100 dark:bg-purple-900/30',
      text: 'text-purple-700 dark:text-purple-300',
      label: 'Converted to Project'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.Draft;

  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${config?.bg} ${config?.text}`}>
      {config?.label}
    </span>
  );
};

export default BidStatusBadge;